import { toDate } from 'date-fns'
import { getItem, setItem } from 'utils/localStorage'

const NUDGED_INVOICES = '__NUDGED_INVOICES__'

export const hoursToThrottleNudge = 24

export type TNudgedInvoice = {
  id: string
  lastNudged: number
}

export const getNudgedInvoices = (): TNudgedInvoice[] =>
  (JSON.parse(getItem(NUDGED_INVOICES) || 'null') as TNudgedInvoice[] | null) || []

export const saveNudgedInvoice = (invoiceId: string): void => {
  const nudgedInvoices = getNudgedInvoices()
  const updatedNudgedInvoice: TNudgedInvoice = { id: invoiceId, lastNudged: toDate(Date.now()).getTime() }
  const invoiceExists = nudgedInvoices.find(ni => ni.id === invoiceId)
  if (!invoiceExists) {
    setItem(NUDGED_INVOICES, JSON.stringify([...nudgedInvoices, updatedNudgedInvoice]))
  } else {
    setItem(
      NUDGED_INVOICES,
      JSON.stringify(nudgedInvoices.map(ni => (ni.id === invoiceId ? updatedNudgedInvoice : ni))),
    )
  }
}

/**
 * A beneficiary is "settled" once it has been fully paid: it had an amount to
 * pay (originalAmount > 0) and nothing is left outstanding (balance === 0).
 *
 * `originalAmount` is the beneficiary's amount as persisted on the invoice, kept apart
 * from `amount`, which is edited while building a payment.
 */
export const isBeneficiarySettled = (beneficiary: { balance?: number; originalAmount?: number } | undefined): boolean =>
  beneficiary?.balance === 0 && (beneficiary?.originalAmount ?? 0) > 0
